import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { checkEmail, EmailCheck, emailDomain } from './email-check';

export const YULAVA_EMAIL_ERROR = 'yulavaEmail';

export interface YulavaEmailError {
  reason: 'syntax' | 'tld' | 'provider';
  domain: string;
  suggestion?: string;
}

/** Devuelve solo los errores bloqueantes. Un campo vacío es válido (usar Validators.required aparte). */
export const yulavaEmailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
  if (value === null || value === undefined || String(value).trim() === '') {
    return null;
  }
  const result = checkEmail(String(value));
  if (result.valid === true) {
    return null;
  }
  const failure = result as Extract<EmailCheck, { valid: false }>;
  const error: YulavaEmailError = {
    reason: failure.reason,
    domain: emailDomain(String(value)),
    suggestion: failure.suggestion,
  };
  return { [YULAVA_EMAIL_ERROR]: error };
};

/** Sugerencia no bloqueante («¿Quisiste decir X?») para el valor actual, o null. */
export function emailSuggestion(value: any): string | null {
  if (value === null || value === undefined || String(value).trim() === '') {
    return null;
  }
  const result = checkEmail(String(value));
  return result.suggestion || null;
}
